/**
 * AVAILABILITY CONFIGURATION
 *
 * This file manages your available dates for bookings.
 * By default, all dates from February 1, 2026 to December 31, 2026 are available.
 *
 * HOW TO MARK DATES AS UNAVAILABLE:
 * Add specific dates to the `unavailableDates` array below.
 * Use the format 'YYYY-MM-DD' (e.g., '2026-03-15')
 *
 * EXAMPLES:
 * - Single date:     '2026-03-15'
 * - Multiple dates:  '2026-03-15', '2026-03-16', '2026-03-17'
 * - Entire weekend:  '2026-03-22', '2026-03-23'
 * - Holidays:        '2026-12-24', '2026-12-25', '2026-12-26'
 */

// List all dates you want to mark as unavailable (booked/blocked)
const unavailableDates = [
  // Example: '2026-03-15', '2026-03-16',
  // Add your unavailable dates here:

];

/**
 * Generates all dates in the specified range and filters out unavailable dates
 */
const generateAvailableDates = () => {
  const dates = [];
  const startDate = new Date('2026-02-01');
  const endDate = new Date('2026-12-31');

  // Generate all dates in range
  for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
    const dateStr = date.toISOString().split('T')[0];

    // Only include dates that are NOT in the unavailable list
    if (!unavailableDates.includes(dateStr)) {
      dates.push(dateStr);
    }
  }

  return dates;
};

export const availableDates = generateAvailableDates();
